if (!customElements.get('chrissie-skin-carousel')) {
  customElements.define('chrissie-skin-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('[data-skin-track]');
      this.controls = this.querySelector('[data-skin-controls]');
      this.previous = this.querySelector('[data-skin-previous]');
      this.next = this.querySelector('[data-skin-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;

      this.frame = 0;
      const update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateControls());
      };
      const previous = () => this.move(-1);
      const next = () => this.move(1);
      this.track.addEventListener('scroll', update, { passive: true });
      this.previous.addEventListener('click', previous);
      this.next.addEventListener('click', next);
      window.addEventListener('resize', update, { passive: true });
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
      if (observer) observer.observe(this.track);
      this.cleanup = () => {
        cancelAnimationFrame(this.frame);
        this.track.removeEventListener('scroll', update);
        this.previous.removeEventListener('click', previous);
        this.next.removeEventListener('click', next);
        window.removeEventListener('resize', update);
        if (observer) observer.disconnect();
      };
      this.updateControls();
    }

    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
      this.cleanup = null;
    }

    updateControls() {
      const first = this.track.firstElementChild;
      const last = this.track.lastElementChild;
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.controls.hidden = !hasOverflow;
      if (!first || !last || !hasOverflow) return;
      const viewport = this.track.getBoundingClientRect();
      const firstRect = first.getBoundingClientRect();
      const lastRect = last.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.previous.disabled = rtl ? firstRect.right <= viewport.right + 2 : firstRect.left >= viewport.left - 2;
      this.next.disabled = rtl ? lastRect.left >= viewport.left - 2 : lastRect.right <= viewport.right + 2;
    }

    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const style = getComputedStyle(this.track);
      const step = card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      const sign = style.direction === 'rtl' ? -1 : 1;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * sign * step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  });
}
